import { Injectable } from '@angular/core';
import { TimeWorkedComponent } from '../../time-worked/time-worked.component';

@Injectable({
  providedIn: 'root'
})
export class CrewTimecardDataService {
  timeWorked: TimeWorkedComponent = null;
  alertMsg: string;
  alertType: string;
  approvedRows: number;
  columnInfoByType: { J: any; M: any; S: any; };
  crewsList: any[];
  dataTable: webix.ui.datatable;
  employees: any[];
  
  employeesToExclude: any[];
  isSubmitted: number;
  loadingValues: boolean = false;
  lockedEmployees: any[];
  multiSelectEmployees: any[] = [];
  newRowID: number;
  payPeriod: any;
  readOnlyGrid: boolean = false;
  rowCount: number;
  rowDeleted: boolean;
  selectedEmployee: any = null;
  selectedEmployees: any[] = [];
  template: any;
  timecardLoaded: boolean = false;
  timecardSaving: boolean = false;
  totalSubmittedRows: number;
  type: string = "all";
  unapprovedRows: number;
  usageMode: string;
  unsavedChanges: boolean;
  unsubmittedRows: number;
  
  rejectReasons: any;
  expenses: any;

  testValue: string;

  constructor() {
  }

  initValues() {
    this.alertMsg = null;
    this.alertType = null;
    this.employeesToExclude = [];
    this.rowDeleted = false;
    this.initRowCounts();
  }

  initRowCounts() {
    this.newRowID = 1;
    this.rowCount = 0;
    this.totalSubmittedRows = 0;
    this.unapprovedRows = 0;
    this.unsubmittedRows = 0;
    this.approvedRows = 0;
  }
}
